/** Farmers Plan User portal — primary action colour (see CHANGELOG 2.0.5). */
export const FP_PRIMARY_ACTION_COLOR = '#4a4d4e';
export const FP_PRIMARY_ACTION_HOVER = '#5c5f60';
export const FP_PRIMARY_ACTION_ACTIVE = '#3a3c3d';
export const FP_PRIMARY_ACTION_SHADOW = '0 10px 20px rgba(52, 64, 84, 0.16)';

/** CSS class wired in index.css for primary CTAs (hover + disabled). */
export const FP_PRIMARY_ACTION_BUTTON_CLASS = 'farm-onboarding-action-button';

export const fpPrimaryActionButtonLayout = {
  width: '100%' as const,
  height: 46,
  borderRadius: 12,
  fontWeight: 600,
};
